/**
 * Round a number to a given decimal place
 * @param {number|string} value - The number to round
 * @param {number|string} [exp] - The decimal place to round to. Positive values round to the right of the decimal point, negative values round to the left of the decimal point
 */
export function Round(value, exp) {
  // If no exp is passed in or it's 0, round to the nearest integer
  // also don't allow exp to be a boolean or an object
  if (value !== null && value !== '' && (exp == null || exp === 0 || exp === '0')) return Math.round(value);

  // Return NaN if either value or exp is not a number or a string or an empty string
  if (
    (typeof value !== 'number' && typeof value !== 'string') ||
    value === '' ||
    (typeof exp !== 'number' && typeof exp !== 'string') ||
    exp === ''
  )
    return NaN;

  // Try to convert value and exp to numbers
  value = +value;
  exp = +exp;

  // Return NaN if the value is not a number or exp is not an integer
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) return NaN;

  // Special case  for really large numbers that Javascript handles as Infinity
  if (value == Infinity || value == -Infinity) return value;

  // The code below splits the value into two parts: the significand and the exponent, if necessary (e.g. 1.2345e4 => ['1.2345', '4'] or 1.2345 => ['1.2345']).
  // It then rounds the significand to the correct decimal place using Math.round, and then reconstructs the number using the exponent and the rounded significand.

  // Shift
  value = value.toString().split('e');
  value = Math.round(+(value[0] + 'e' + (value[1] ? +value[1] + exp : exp)));

  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp));
}
